import React, {
  Component,
  useContext,
  useEffect,
  useReducer,
  useState,
} from "react";
import { MenuList } from "./Menu";
import { Link } from "react-router-dom";
import Collapse from "react-bootstrap/Collapse"; /// Link

const UserSidebar = ({ state, setState, menuListData }) => {
  const loginDetails = JSON.parse(localStorage.getItem("login_Details"));
  const { name, email } = loginDetails || {};
  const token = localStorage.getItem("access_token_admin");
  let path = window.location.pathname;
  path = path.split("/");
  path = path[path.length - 1];

  const formMatch = window.location.pathname.match(/^\/grant-scheme\/form\/(.+)$/);
  const descMatch = window.location.pathname.match(/^\/grant-scheme\/description\/(.+)$/);
  const isGrantSchemedescMatch = window.location.pathname.match(/^\/grant-scheme/);

  useEffect(() => {
    if (path == "user-grievance-management") {
      setState({ active: "Grievance Management" });
    }
    else if (formMatch || descMatch || isGrantSchemedescMatch) {
      setState({ active: "Schemes & Scholarship" });
    } else {
      setState({ active: "" });
    }
  }, [path]);


  // console.log("path======>",path);
  // console.log("menuListData======>",menuListData);

  const handleMenuActive = (status) => {
    setState({ active: status });
    if (state.active === status) {
      setState({ active: "" });
    }
  };
  const handleSubmenuActive = (status) => {
    setState({ activeSubmenu: status });
    if (state.activeSubmenu === status) {
      setState({ activeSubmenu: "" });
    }
  };
  return (
    <>
      {menuListData?.map((data, index) => {
        let menuClass = data.classsChange;
        if (menuClass === "menu-title") {
          return (
            <li className={menuClass} key={index}>
              {data.title}
            </li>
          );
        } else {
          return (
            <li
              className={` ${state.active === data.title ? "mm-active" : ""}`}
              key={index}
            >
              {data.content && data.content.length > 0 ? (
                <>
                  <Link
                    to={"#"}
                    className="has-arrow d-flex gap-1"
                    onClick={() => {
                      handleMenuActive(data.title);
                    }}
                  >
                    {data.iconStyle}{" "}
                    <div className="nav-text txt-wrapper">
                      {data.title}
                      {data.update && data.update.length > 0 ? (
                        <span className="badge badge-xs badge-danger ms-2">
                          {data.update}
                        </span>
                      ) : (
                        ""
                      )}
                    </div>
                  </Link>
                  <Collapse in={state.active === data.title ? true : false}>
                    <ul className={`${menuClass === "mm-collapse" ? "mm-show" : ""}`}>
                      {data.content &&
                        data.content.map((item, index) => {
                          let url = item.to;

                          // Check if the parent menu title is "Venu Infra"
                          if (data.title === "Assessment Management" || data.title === "Grant Schemes") {
                            const params = new URLSearchParams({
                              access_token: token,
                              name: name,
                              email: email,
                            }).toString();

                            url += url?.includes('?') ? `&${params}` : `?${params}`;
                          }

                          return (
                            <li
                              key={index}
                              className={`${state.activeSubmenu === item.title ? "mm-active" : ""
                                }`}
                            >
                              {item.content && item.content.length > 0 ? (
                                <>
                                  <Link
                                    to={url}
                                    className={item.hasMenu ? "has-arrow" : ""}
                                    onClick={() => {
                                      handleSubmenuActive(item.title);
                                    }}
                                  >
                                    {item.title}
                                  </Link>
                                  <Collapse
                                    in={state.activeSubmenu === item.title ? true : false}
                                  >
                                    <ul
                                      className={`${menuClass === "mm-collapse" ? "mm-show" : ""
                                        }`}
                                    >
                                      {item.content &&
                                        item.content.map((subItem, subIndex) => {
                                          let subUrl = subItem.to;


                                          if (data.title === "Assessment Management" || data.title === "Grant Schemes" ) {
                                            const subParams = new URLSearchParams({
                                              access_token: token,
                                              name: name,
                                              email: email,
                                            }).toString();

                                            subUrl += subUrl.includes('?') ? `&${subParams}` : `?${subParams}`;
                                          }

                                          return (
                                            <li key={subIndex}>
                                              <Link
                                                className={`${path === subItem.to ? "mm-active" : ""
                                                  }`}
                                                to={subUrl}
                                              >
                                                {subItem.title}
                                              </Link>
                                            </li>
                                          );
                                        })}
                                    </ul>
                                  </Collapse>
                                </>
                              ) : (
                                <Link className="" to={url}>
                                  {item.title}
                                </Link>
                              )}
                            </li>
                          );
                        })}
                    </ul>
                  </Collapse>

                </>
              ) : (
                <Link to={data.to}>
                  {data.iconStyle}
                  <span className="nav-text">{data.title}</span>
                </Link>
              )}
            </li>
          );
        }
      })}
    </>
  );
};

export default UserSidebar;
